import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  cancelEditingOrder,
  loadEditOrder,
  removeItemFromCheckoutCartStart,
} from '../../redux/modules/cart'
import { clearMenuItem, selectMenuItem } from '../../redux/modules/order'
import {
  selectCurrentLocationWithAddress,
  selectMenuItemForEdit,
} from '../../redux/modules/selectors'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { CheckoutCart } from '../cart/Cart'
import { SpinnerCard } from '../common/Layout'
import { Location, LocationBuilding, LocationContainer } from '../common/Location'
import SidebarDeliveryLocation from '../common/SidebarDeliveryLocation'
import PersonalizeOrder from '../personalize-order/PersonalizeOrder'

export class CheckoutSidebar extends Component {
  constructor(props) {
    super(props)
    const { clearMenuItem } = this.props
    clearMenuItem()

    this.handleClose = this.handleClose.bind(this)
  }
  handleClose() {
    this.props.clearMenuItem()
    this.props.cancelEditingOrder()
  }

  render() {
    const {
      checkoutCart,
      checkoutCartError,
      checkoutError,
      couponUsage,
      creditUsage,
      deliveryDropoff,
      isAvailableCreditsLoading,
      isCartValid,
      isCheckoutCartLoading,
      isCheckoutProcessing,
      isDeliveryDropoffLoading,
      isEditingOrder,
      isLocationLoading,
      loadEditOrder,
      location,
      menuItemForEdit,
      normalizedMenuItem,
      programUsage,
      removeItemFromCheckoutCartStart,
      selectMenuItem,
      storedCurrencyUsage,
    } = this.props
    return [
      <SpinnerCard
        key="location"
        spinnerActive={
          isLocationLoading ||
          isDeliveryDropoffLoading ||
          isCheckoutCartLoading ||
          isAvailableCreditsLoading
        }
      >
        <SidebarDeliveryLocation
          deliveryDropoff={deliveryDropoff}
          loading={isDeliveryDropoffLoading}
          style={{ paddingBottom: '10px' }}
        />
        {location && (
          <Location>
            <LocationContainer>
              <LocationBuilding
                address={location.address}
                name={location.deliveryLocationName}
                showLink={false}
              />
            </LocationContainer>
          </Location>
        )}
        <hr />
        {checkoutCart && deliveryDropoff && location && (
          <CheckoutCart
            cart={checkoutCart}
            checkoutCartError={checkoutCartError}
            checkoutError={checkoutError}
            couponUsage={couponUsage}
            creditUsage={creditUsage}
            deleteMenuItem={removeItemFromCheckoutCartStart}
            dropoffId={deliveryDropoff.dropoffId}
            editMenuItem={loadEditOrder}
            isCheckoutProcessing={isCheckoutProcessing}
            isEditingFromMenu={false}
            isEditingPastOrder={false}
            isValid={isCartValid}
            locationId={location.deliveryLocationId}
            onCheckout={() => {
              // manually trigger a form submission from far away
              pushSnowplow(toOrderProcessSchema('daily', 'checkout', null))
              document.getElementById('checkout').click()
            }}
            programUsage={programUsage}
            selectMenuItem={selectMenuItem}
            showEditLinks="true"
            storedCurrencyUsage={storedCurrencyUsage}
          />
        )}
        {normalizedMenuItem && menuItemForEdit && isEditingOrder ? (
          <PersonalizeOrder
            addMoreIsHidden="true"
            dropoffId={deliveryDropoff.dropoffId}
            handleClose={this.handleClose}
            isEditingFromCheckout="true"
            isEditingOrder={isEditingOrder}
            locationId={location.deliveryLocationId}
            menuItemForEdit={menuItemForEdit}
            menuItemId={menuItemForEdit.menuItemId}
            normalizedMenuItem={normalizedMenuItem}
          />
        ) : null}
      </SpinnerCard>,
    ]
  }
}

const mapStateToProps = state => {
  const { checkoutError, isCartValid, isCheckoutProcessing, isDeliveryLoading } = state.checkout
  const { normalizedMenuItem } = state.personalize
  const { deliveryDropoff, isDeliveryDropoffLoading } = state.delivery
  const { availableCredits, isAvailableCreditsLoading } = state.creditHistory
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const {
    checkoutCart,
    checkoutCartError,
    couponUsage,
    creditUsage,
    isCheckoutCartLoading,
    isEditingOrder,
    programUsage,
    storedCurrencyUsage,
  } = state.cart
  const menuItemForEdit = selectMenuItemForEdit(state)
  return {
    availableCredits,
    checkoutCart,
    checkoutCartError,
    checkoutError,
    couponUsage,
    creditUsage,
    deliveryDropoff,
    isAvailableCreditsLoading,
    isCartValid,
    isCheckoutCartLoading,
    isCheckoutProcessing,
    isDeliveryDropoffLoading,
    isDeliveryLoading,
    isEditingOrder,
    isLocationLoading,
    location,
    menuItemForEdit,
    normalizedMenuItem,
    programUsage,
    storedCurrencyUsage,
  }
}

const mapDispatchToProps = {
  cancelEditingOrder,
  clearMenuItem,
  loadEditOrder,
  removeItemFromCheckoutCartStart,
  selectMenuItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSidebar)
